import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contacts-dialog-confirm-contact-delete',
    styleUrls: ['./contact-confirm-delete-modal.component.scss'],
    templateUrl: './contact-confirm-delete-modal.component.html',
})
export class ContactsDialogConfirmContactDeleteComponent implements OnInit {
    private contactId = 0;

    // For AppDialogWrapperService pattern
    data: any;
    dialogRef: { close: (result?: any) => void };

    ngOnInit() {
        if (this.data) {
            this.contactId = this.data.contactId;
        }
    }

    // Public Methods
    public onCancelClick(): void {
        this.dialogRef.close('cancel');
    }

    public saveEdit() {
        this.dialogRef.close(this.contactId);
    }
}
